<template>
  	<span>
		<div @click="navigatoTo"
			class="col-md-9 margin-left-14">
			<a v-if="notifyUser.typeAlert === 'status_changed'"> 
					{{ notifyUser.actionedByUser.name }} {{ notifyUser.status }} cadastro do cliente {{ notifyUser.client.name  }}.
					<i class="fa fa-check text-success"></i>
			</a>
			<a v-if="notifyUser.typeAlert === 'client_added'"> 
				{{ notifyUser.actionedByUser.name }} acabou de inseriu um novo cadastro de cliente. Nome: {{ notifyUser.client.name  }}.
				<i class="fa fa-check text-success"></i>
			</a>

			<br>
		</div>
		<div class="col-md-1" @click="close">
			<i class="fa fa-window-close icon"></i> 
		</div>
		<div class="space-50"></div>
		<small class="pull-right">{{ notifyUser.date | time }}</small>
	</span>
</template>

<script>
export default {
  name: 'NotifyUserOnCliet',
  props: {
    notifyUser: {
      type: Object,
      required: true
    }
  },
  methods: {
    navigatoTo () {
      if (this.$route.name === 'clients_add') {
        this.$router.push({name: 'clients_add', params: {clientId: this.notifyUser.client.id}})
      } else {
        this.$router.push({name: 'clients_details', params: {clientId: this.notifyUser.client.id}})
      }
      this.$emit('decreaseNotification', this.notifyUser)
    },
    close () {
      this.$emit('decreaseNotification', this.notifyUser)
    }
  }
}
</script>

<style>
  a:hover {
    color: #777777;
  }

  a {
    color: #777777;
  }

  .icon {
    color: #189ce2;
    border-color: #168ccb;
    font-size: 1.8rem;
	margin: -5px;
  }

</style>


// WEBPACK FOOTER //
// NotifyUserOnClient.vue?2d21775d